import { render, staticRenderFns } from "./QuizLevelEnd.vue?vue&type=template&id=45a1c4aa&"
import script from "./QuizLevelEnd.vue?vue&type=script&lang=js&"
export * from "./QuizLevelEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports